// extracted by mini-css-extract-plugin
module.exports = {"root":"ColorPicker_root__kRn5g","image-container":"ColorPicker_image-container__gGB4y","colors-container":"ColorPicker_colors-container__05pd5"};